'use client';

interface SlaCountdownProps {
  installDate: string;
}

const SlaCountdown = ({ installDate }: SlaCountdownProps) => {
  try {
    const installMidnight = new Date(installDate);
    if (isNaN(installMidnight.getTime())) return null;
    installMidnight.setHours(0, 0, 0, 0);

    const todayMidnight = new Date();
    todayMidnight.setHours(0, 0, 0, 0);

    const diffDays = Math.round(
      (installMidnight.getTime() - todayMidnight.getTime()) / (1000 * 60 * 60 * 24)
    );

    let label: string;
    let color: string;

    if (diffDays > 1) {
      label = `Install in ${diffDays} days`;
      color = '#16a34a';
    } else if (diffDays === 1) {
      label = 'Install tomorrow';
      color = '#F5A623';
    } else if (diffDays === 0) {
      label = 'Install today';
      color = '#E89A3C';
    } else {
      label = `Overdue by ${Math.abs(diffDays)} day(s)`;
      color = '#dc2626';
    }

    return (
      <span
        className="inline-flex items-center gap-1 text-[11px] font-semibold"
        style={{ color }}
      >
        <svg
          className="w-3 h-3"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6 v6 l4 2" strokeLinecap="round" />
        </svg>
        {label}
      </span>
    );
  } catch {
    return null;
  }
};

export default SlaCountdown;
